module.exports = __webpack_public_path__ + "static/img/30.34beb0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/30.jpg
// module id = 2d3u
// module chunks = 1